import React from 'react'
import { Spinner } from '../../svg/Spinner'

export const Loader = () => {
  return (
    <div className='absolute top-0 left-0 right-0 bottom-0 flex justify-center items-center'>
      <Spinner style={{ color: 'blue' }} />
    </div>
  )
}